import styled from 'styled-components';

import { GlobalToken } from 'antd';

interface ToggleContainerProps {
  $switchState: boolean;
  $colorOn: string;
  $colorOff: string;
  $toggleColorOn: string;
  $toggleColorOff: string;
  $isDisabled: boolean;
  theme: { token: GlobalToken };
}

const ToggleContainer = styled.div<ToggleContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
  padding: ${({ theme: { token } }) => token.paddingXS}px 0px ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.paddingXS}px;
  cursor: initial;
  position: relative;
  ${({ $isDisabled }) => $isDisabled && 'pointer-events: none;'}
    
    .ant-switch-loading-icon {
      top: 30%;
    }

    .ant-click-animating-node {
      animation: unset;
    }

  .switch-title {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    opacity: ${({ $isDisabled }) => ($isDisabled ? 0.3 : 1)};
    text-align: center;
  }

  .switch-options {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
    width: 100%;

    .switch-value-text {
      color: ${({ theme: { token } }) => token.colorText};
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      margin-right: ${({ theme: { token } }) => token.marginXXS}px;
    }
  }

  .spinner {
    position: absolute;
  }

  .tooltip-overlay {
    width: 358px;
    display: flex;
  }

  .ant-switch-checked {
    background-color: ${({ theme: { token } }) => token.colorBorderSecondary};

    .ant-switch-handle::before {
      background-color: ${({ theme: { token } }) => token.colorWhite};
    }

    &:focus {
      box-shadow: unset;
    }
  }
`;
export default ToggleContainer;
